module.exports = __webpack_public_path__ + "static/media/symbol-gm.3db5b9ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-gm.svg
// module id = ./src/assets/images/symbol-gm.svg
// module chunks = 0